/* eslint-disable arrow-body-style */
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import { DsmButton } from "@dsm-dcs/design-system-react";
import { roiCalculatorStyles } from "../../../../ThemeProvider";
import { useIntl } from "../../../../../_metronic/i18n/customUseIntl";
import DsmDialog from "../CommonDataParts/DsmDialog";

const METHODS_I18N_PREFIX = "SUSTELL.ROI.METHODS";

const KPI_ROWS = [
  "PRODUCTION",
  "REVENUE",
  "FEED_COST_SAVINGS",
  "FOOTPRINT_CHANGE",
  "GROSS_BENEFIT",
  "ROI_ABS",
  "ROI_PCT",
  "CARBON_VALUE",
  "ROI_CARBON_ABS",
  "ROI_CARBON_PCT",
  "GHG_ABATED",
  "NET_COST",
  "COST_OF_ABATEMENT",
];

const POULTRY_DATA_ROWS = ["1", "2", "3", "4", "5", "6", "7", "8"];
const PIG_DATA_ROWS = ["1", "2", "3", "4", "5", "6", "7", "8"];

type CalculationMethodsModalProps = {
  open: boolean;
  onClose: () => void;
};

const CalculationMethodsModalDialog = ({
  open,
  onClose,
}: CalculationMethodsModalProps) => {
  const intl = useIntl();
  const classes = roiCalculatorStyles();

  const totalAnimalRows = Math.max(
    POULTRY_DATA_ROWS.length,
    PIG_DATA_ROWS.length,
  );

  return (
    <DsmDialog
      openDialog={open}
      title={intl.formatMessage({
        id: `${METHODS_I18N_PREFIX}.MODAL_TITLE`,
      })}
      description={intl.formatMessage({
        id: `${METHODS_I18N_PREFIX}.MODAL_DESCRIPTION`,
      })}
      variant="semiWide"
      icon={{ name: "general/info-circle", variant: "completed" }}
      handleClose={onClose}
    >
      <div style={{ marginTop: "24px", marginBottom: "32px" }}>
        <Typography className={classes.methodsModalSectionTitle}>
          {intl.formatMessage({ id: `${METHODS_I18N_PREFIX}.SECTION_METHODS` })}
        </Typography>

        <Table>
          <TableHead>
            <TableRow>
              <TableCell style={{ width: "27.87%" }}>
                {intl.formatMessage({ id: `${METHODS_I18N_PREFIX}.COL_KPI` })}
              </TableCell>

              <TableCell style={{ width: "36.17%" }}>
                {intl.formatMessage({
                  id: `${METHODS_I18N_PREFIX}.COL_DEFINITION`,
                })}
              </TableCell>

              <TableCell style={{ width: "35.96%" }}>
                {intl.formatMessage({
                  id: `${METHODS_I18N_PREFIX}.COL_CALCULATION`,
                })}
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {KPI_ROWS.map((kpi) => (
              <TableRow key={kpi}>
                <TableCell
                  className={classes.methodsModalKpiColumn}
                  style={{ width: "27.87%" }}
                >
                  {intl.formatMessage({
                    id: `${METHODS_I18N_PREFIX}.${kpi}.KPI`,
                  })}
                </TableCell>

                <TableCell
                  className={classes.methodsModalColumns}
                  style={{ width: "36.17%" }}
                >
                  {intl.formatMessage({
                    id: `${METHODS_I18N_PREFIX}.${kpi}.DEFINITION`,
                  })}
                </TableCell>

                <TableCell
                  className={classes.methodsModalColumns}
                  style={{ width: "35.96%" }}
                >
                  {intl.formatMessage({
                    id: `${METHODS_I18N_PREFIX}.${kpi}.CALCULATION`,
                  })}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>

      <hr />

      <div style={{ marginTop: "32px", marginBottom: "32px" }}>
        <Typography className={classes.methodsModalSectionTitle}>
          {intl.formatMessage({ id: `${METHODS_I18N_PREFIX}.SECTION_DATA` })}
        </Typography>

        <Table>
          <TableHead>
            <TableRow>
              <TableCell style={{ width: "50%" }}>
                {intl.formatMessage({
                  id: `${METHODS_I18N_PREFIX}.COL_POULTRY`,
                })}
              </TableCell>

              <TableCell style={{ width: "50%" }}>
                {intl.formatMessage({ id: `${METHODS_I18N_PREFIX}.COL_PIG` })}
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {Array.from({ length: totalAnimalRows }, (_, index) => {
              const poultryRow = POULTRY_DATA_ROWS[index];
              const pigRow = PIG_DATA_ROWS[index];

              return (
                <TableRow key={`data-row-${index + 1}`}>
                  <TableCell
                    className={classes.methodsModalColumns}
                    style={{ width: "50%" }}
                  >
                    {poultryRow
                      ? intl.formatMessage({
                          id: `${METHODS_I18N_PREFIX}.DATA.POULTRY.${poultryRow}`,
                        })
                      : ""}
                  </TableCell>

                  <TableCell
                    className={classes.methodsModalColumns}
                    style={{ width: "50%" }}
                  >
                    {pigRow
                      ? intl.formatMessage({
                          id: `${METHODS_I18N_PREFIX}.DATA.PIG.${pigRow}`,
                        })
                      : ""}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>

      <div>
        <DsmButton
          variant="primary"
          widthFull
          onClick={onClose}
          style={{ display: "block" }}
        >
          {intl.formatMessage({ id: "GENERAL.OK" })}
        </DsmButton>
      </div>
    </DsmDialog>
  );
};

export default CalculationMethodsModalDialog;
